/**
 * Ogrenci yuzunde (katalog, kurs detay, favoriler...) yildiz + puan blogu
 * yalnizca gercek degerlendirme varsa gosterilir.
 *
 * `rating_count` 0 / null / eksik ise blok HIC render edilmez ("0.0 (0)"
 * gibi sahte bir puan izlenimi verilmez). Admin ekranlari bu yardimciyi
 * kullanmaz; orada puan tablo verisi olarak oldugu gibi gosterilir.
 *
 * @param {{rating_count?: number|null}|null|undefined} course
 * @returns {boolean}
 */
export function hasRating(course) {
  return Number(course?.rating_count) > 0;
}
